import template from './bToggleInput.html';

export function bToggleInputDirective() {
  'ngInject';
  return {
    restrict: 'E',
    template: template,
    controller: bToggleInputController,
    controllerAs: 'bToggleInput',
    bindToController: true,
    require: 'ngModel',
    scope: {
      label: '@',
      ngModel: '=?',
      ngDisabled: '=',
      ngChange: "&",
      hideToggle: "=?",
      ngValue: "=?"
    }
  };
}

class bToggleInputController {
  constructor() {
    'ngInject';
  }
}
